import React from 'react';
import { SxProps, Theme } from '@mui/material';
import { makeStyles } from '@mui/styles';

import Fab from '@mui/material/Fab';
import Tooltip from '@mui/material/Tooltip';
import AVDialogButton from '../AVDialogButton/AVDialogButton';
import { useTranslation } from 'react-i18next';
import VideocamIcon from '@mui/icons-material/Videocam';
import VideocamOffIcon from '@mui/icons-material/VideocamOff';
import useLocalVideoToggle from '../../../hooks/useLocalVideoToggle/useLocalVideoToggle';

const useStyles = makeStyles<Theme>((theme) => ({
  fab: {
    margin: theme.spacing(1),
    // size: 'large', // somehow does not work here.
  },
}));

interface CompositeVideoButtonProps {
  disabled?: boolean;
  /**
   * Optional extra styles forwarded to the video device dialog's modal-wrapper.
   * Use it to shift the dialog away from the EMDR sidebar on the practitioner page.
   */
  dialogWrapperSx?: SxProps<Theme>;
}

export default function CompositeVideoButton(props: CompositeVideoButtonProps) {
  const classes = useStyles();
  const [isVideoEnabled, toggleVideoEnabled] = useLocalVideoToggle();
  const [t] = useTranslation();
  const muteVideoTitle = t('Mute Video');
  const unmuteVideoTitle = t('Unmute Video');
  return (
    <div>
      <Tooltip
        title={isVideoEnabled ? muteVideoTitle : unmuteVideoTitle}
        placement="top"
        PopperProps={{ disablePortal: true }}
      >
        <Fab
          className={classes.fab}
          size={'large'}
          onClick={toggleVideoEnabled}
          disabled={props.disabled}
          data-testid="pwid-video-toggle"
        >
          {isVideoEnabled ? <VideocamIcon /> : <VideocamOffIcon />}
        </Fab>
      </Tooltip>
      <AVDialogButton isAudio={false} t={t} dialogWrapperSx={props.dialogWrapperSx} />
    </div>
  );
}
